import styled from 'styled-components';
import {
  backgroundImage,
  backgroundPosition,
  height,
  width,
  minHeight,
  HeightProps,
  MinHeightProps,
  BackgroundPositionProps,
  WidthProps,
} from 'styled-system';

export interface BackgroundImagesProps
  extends HeightProps,
  WidthProps,
  MinHeightProps,
  BackgroundPositionProps {
  backgroundImages: string[];
}

const BackgroundImage = styled.div<BackgroundImagesProps>`
  ${height};
  ${width};
  ${minHeight};
  display: flex;
  background-size: cover;
  background-position-y: 50%;
  background-position-x: 50%;
  ${backgroundPosition};
  ${(props: BackgroundImagesProps): string =>
    backgroundImage({
      backgroundImage: props.backgroundImages.map(
        (img: string): string => `url(${img})`
      ),
    })};
`;

export default BackgroundImage;
